import { render, staticRenderFns } from "./CardVideo.vue?vue&type=template&id=266ceefb&scoped=true"
import script from "./CardVideo.vue?vue&type=script&lang=js"
export * from "./CardVideo.vue?vue&type=script&lang=js"
import style0 from "../styles/CardVideo.css?vue&type=style&index=0&id=266ceefb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ceefb",
  null
  
)

export default component.exports